import { ServiceFrequencyEnum, toServiceFrequency } from '@rover/types/src/ServiceFrequency';
import { WEEKDAY_ENGLISH_PARAMS } from '@rover/utilities/weekday';

/**
 * A repeating service travels to the contact page the way that page reads it: a
 * `frequency` next to one parameter per weekday — `monday=true`, `friday=true` — and the
 * `start_date` the repetition starts from.
 */
export const FREQUENCY_PARAM = 'frequency';

export const parseFrequency = (value?: string | null): ServiceFrequencyEnum =>
  toServiceFrequency(value ?? undefined) ?? ServiceFrequencyEnum.ONE_TIME;

export const isRecurringFrequency = (value?: string | null): boolean =>
  parseFrequency(value) === ServiceFrequencyEnum.REPEAT;

// The weekdays a repeating selection covers, as day-of-week indexes (sunday = 0).
export const parseWeekDays = (params: URLSearchParams): number[] =>
  WEEKDAY_ENGLISH_PARAMS.filter(({ paramName }) => !!params.get(paramName)).map(
    ({ index }) => index
  );

export const setWeekDayParams = (params: URLSearchParams, weekDays: number[]): void => {
  WEEKDAY_ENGLISH_PARAMS.forEach(({ paramName, index }) => {
    if (weekDays.includes(index)) params.set(paramName, 'true');
    else params.delete(paramName);
  });
};

export const sortWeekDays = (weekDays: number[]): number[] =>
  [...new Set(weekDays)].sort((a, b) => a - b);
